// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"ValidationError_bi-chevron-down__1IXLN","root":"ValidationError_root__2BqiA"};